<template>
    <div class="card mt-2" style="margin-bottom:10px">


        <h6 style="background: #0078be!important;" class="tituloMovil card-title bg-primary text-white w-100 p-1">
            ESPECIALIDAD PARA LA ATENCIÓN
        </h6>

        <div class="row mb-3">
            <div class="col-md-6">
                <label for="example-text-input" class="form-control-label" style="font-weight: bold; font-size: 12px;">
                    Nombre de la Especialidad (*):
                </label>

                <v-select placeholder="Seleccione la especialidad" class="my-custom-v-select"
                    label="especialidad_nombre" v-model="doctor.especialidad" :options="especialidades"
                    @option:selected="cargarDoctores">
                    <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events">
                    </template>
                </v-select>
            </div>

            <div class="col-md-6">
                <label for="example-text-input" class="form-control-label" style="font-weight: bold; font-size: 12px;">
                    Nombre del Doctor (*):
                </label>

                <v-select placeholder="Seleccione el doctor" class="my-custom-v-select" label="doctor_nombre"
                    v-model="doctor.name" @option:selected="SeleccionaDoctor" :options="doctores"
                    :disabled="!doctor.especialidad">
                    <template #search="{ attributes, events }">
                        <input class="vs__search" v-bind="attributes" v-on="events">
                    </template>
                </v-select>
            </div>
        </div>

        <h6 style="background: #0078be!important;" class="tituloMovil card-title bg-primary text-white w-100 p-1">
            SIGNOS VITALES
        </h6>
        <form @submit.prevent="enviarDatos">
            <div class="row">
                <div class="col-md-6">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Presión arterial sistólica
                                </th>
                                <td>
                                    <cleave v-model="formData.presionSistolica" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Presión arterial diastólica
                                </th>
                                <td>
                                    <cleave v-model="formData.presionDiastolica" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Presión arterial media</th>
                                <td>
                                    <cleave disabled v-model="formData.presionMedia" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>

                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Frecuencia respiratoria</th>
                                <td>
                                    <cleave v-model="formData.frecuenciaRespiratoria" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>


                        </tbody>
                    </table>
                </div>

                <div class="col-md-6">
                    <table class="table table-bordered">
                        <tbody>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Frecuencia cardíaca</th>
                                <td>
                                    <cleave v-model="formData.frecuenciaCardiaca" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Saturación de oxígeno</th>
                                <td>
                                    <cleave v-model="formData.saturacionOxigeno" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Temperatura</th>
                                <td>
                                    <cleave v-model="formData.temperatura" :options="number" class="form-control sm"
                                        placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                            <tr>
                                <th class="form-control-label" style="font-size: 14px;">Perimetro cefálico</th>
                                <td>
                                    <cleave v-model="formData.perimetroCefalico" :options="number"
                                        class="form-control sm" placeholder="0" type="text" inputmode="decimal" />
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>

            <h6 style="background: #0078be!important;"
                class="mt-2 tituloMovil card-title bg-primary text-white w-100 p-1">DATOS
                ANTROPOMÉTRICOS</h6>
            <div class="row">
                <div class="col-md-3">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Peso (kg):
                            *</label>
                        <cleave v-model="formData.peso" required :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Talla/estatura (m): *</label>
                        <cleave v-model="formData.talla" required :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">I.M.C:</label>
                        <cleave v-model="formData.imc" disabled :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>

                <div class="col-md-3">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Perimetro
                            Abdominal (cm):</label>
                        <cleave v-model="formData.perimetroAbdominal" :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>
            </div>

            <h6 style="background: #0078be!important;"
                class="tituloMovil mt-2 card-title bg-primary text-white w-100 p-1">
                MEDICIONES CAPILARES</h6>
            <div class="row">
                <div class="col-md-4">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Glucosa
                            capilar:</label>
                        <cleave v-model="formData.glucosaCapilar" :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Valor de
                            hemoglobina:</label>
                        <cleave v-model="formData.hemoglobina" :options="number" class="form-control sm" placeholder="0"
                            type="text" inputmode="decimal" />
                    </div>
                </div>

                <div class="col-md-4">
                    <div class="form-group">
                        <label style="font-size: 14px; color: #67748e;"
                            class="form-control-label d-block text-left">Valor de
                            hemoglobina corregido:</label>
                        <cleave v-model="formData.hemoglobinaCorregida" :options="number" class="form-control sm"
                            placeholder="0" type="text" inputmode="decimal" />
                    </div>
                </div>
            </div>

            <hr />

            <div v-if="!isMobile">
                <div class="row">
                    <div class="col-12 d-flex justify-content-end">
                        
                        <button type="submit" class="btn btn-primary btn-sm">Confirmar</button>
                    </div>
                </div>
            </div>

            <div v-else>
                <div class="row">
                    <div class="col-12 d-grid gap-2">
                        <button type="submit" class="btn btn-primary btn-sm">Confirmar</button>
                        
                    </div>
                </div>
            </div>
        </form>
    </div>

</template>

<script>
/* eslint-disable */
import { filtrarEspecialidades } from '@/config/especialidades';

export default {
    name: "Signos-Vitales",
    data() {
        return {
            isMobile: this.$isMobile,
            tokenAuth: localStorage.getItem("tokenAuth"),

            doctor: {
                name: '',
                especialidad: ''
            },
            especialidades: [], // Lista de especialidades
            doctores: [], // Lista de doctores
            datosEspecialidades: [],
            datosDoctores: [],
            formData: {
                frecuenciaCardiaca: '',
                frecuenciaRespiratoria: '',
                glucosaCapilar: '',
                hemoglobina: '',
                hemoglobinaCorregida: '',
                imc: '',
                perimetroAbdominal: '',
                perimetroCefalico: '',
                peso: '',
                presionDiastolica: '',
                presionMedia: '',
                presionSistolica: '',
                saturacionOxigeno: '',
                talla: '',
                temperatura: '',
            },

            number: {
                numeral: true,
                numeralPositiveOnly: true,
                noImmediatePrefix: true,
                rawValueTrimPrefix: true,
                numeralIntegerScale: 9,
                numeralDecimalScale: 3
            }
        };
    },
    watch: {
        // Observa los cambios en peso y talla para calcular el IMC automáticamente
        "formData.peso": "calcularIMC",
        "formData.talla": "calcularIMC",
        "formData.presionSistolica": "calcularPAM",
        "formData.presionDiastolica": "calcularPAM"
    },
    mounted() {


        const id = this.$route.params.id;

        if (this.isMobile) {
            this.$eventBus.emit("activeShowMenu");
        }

        this.loadEspecialidadesDoctores()




    },
    methods: {
        calcularIMC() {
            const peso = parseFloat(this.formData.peso);
            const talla = parseFloat(this.formData.talla);

            if (!isNaN(peso) && !isNaN(talla) && talla > 0) {
                // Fórmula del IMC: peso (kg) / (talla (m) * talla (m))
                this.formData.imc = (peso / (talla * talla)).toFixed(2);
            } else {
                this.formData.imc = "";
            }
        },

        calcularPAM() {
            const sistolica = parseFloat(this.formData.presionSistolica);
            const diastolica = parseFloat(this.formData.presionDiastolica);

            if (!isNaN(sistolica) && !isNaN(diastolica) && diastolica > 0) {

                this.formData.presionMedia = ((sistolica) + (diastolica * 2)) / 3

            } else {
                this.formData.presionMedia = ""
            }

        },

        loadEspecialidadesDoctores() {

            this.$https.post('/especialidades/getLoadEspecialidadDoctoresAll', { busqueda: this.busquedaInput }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {


                this.loading = false;

                if (response.data.code === 200) {

                    // Usar la función global para filtrar especialidades
                    this.especialidades = filtrarEspecialidades(response.data.datos);

                } else {
                    this.especialidades = []
                }


            }).catch(error => {


                this.loading = false;

                this.$toast.error("Ocurrió un error inesperado", {
                    position: "top-right",
                    max: 10
                })


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })



        },

        enviarDatos() {
            if (!this.doctor.especialidad) {
                alert('Debe seleccionar una especialidad.');
                return;
            }
            if (!this.doctor.name) {
                alert('Debe seleccionar un doctor.');
                return;
            }

            // Si ambas validaciones pasan, aquí puedes continuar con el envío de datos
            //alert('Datos enviados correctamente.');


            let datos = {
                signosVitales: this.formData,
                especialidad: this.datosEspecialidades,
                doctor: this.datosDoctores,
                paciente: {
                    codPaciente: this.$route.params.id
                },
                user: {
                    dni: JSON.parse(localStorage.getItem("userData") || "{}")?.cedula || "",
                    displayName: JSON.parse(localStorage.getItem("userData") || "{}")?.displayName || "",

                }
            }


            this.showLoading2('Registrando, por favor espere...')

            this.$https.post('/consulta/getInsertConsulta', { datos }, {
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": this.tokenAuth,
                }
            }).then(response => {

                if (response.data.code === 200) {

                    this.$swal.fire({
                        title: response.data.message,
                        icon: "success"
                    }).then(() => {
                        this.$router.push({ name: 'listadoPacientes' });
                    });

                }


            }).catch(error => {



                if (error?.response?.status === 400) {
                    this.$swal.fire({
                        title: "Ocurrió algo!",
                        html: `<p style="color: #eb1265; font-weight: bold; font-size: 13px;">${error.response.data.message}</p>`, // Usa HTML para darle formato
                        icon: "warning",
                        width: "400px",
                        customClass: {
                            confirmButton: "btn btn-primary",
                            cancelButton: "btn btn-outline-secondary ml-1",
                        },
                        buttonsStyling: false,
                    });
                }


                if (error?.response?.status === 401) {
                    this.showSessionExpiredAlert()
                }



            })




        },

        cargarDoctores(especialidad) {

            // Limpiar el campo de doctores al seleccionar una nueva especialidad
            this.doctor.name = ''; // Resetear el valor del v-select de doctores

            this.datosEspecialidades = ''
            this.datosDoctores = ''

            let datos = {
                idEspecialidad: especialidad.especialidad_id,
                codigo: especialidad.codigo,
                especialidad: especialidad.especialidad_nombre
            }

            this.datosEspecialidades = datos

            if (especialidad && especialidad.doctores) {
                this.doctores = especialidad.doctores; // Cargar los doctores de la especialidad seleccionada
            } else {
                this.doctores = []; // Limpiar la lista de doctores si no hay especialidad seleccionada
            }
        },

        SeleccionaDoctor(doctor) {

            let datos2 = {
                cedula: doctor.cedula,
                doctor: doctor.doctor_nombre
            }

            this.datosDoctores = datos2

        },


    }
};
</script>

<style scoped>
.table {
    margin-bottom: 0;
}

.form-control {
    width: 100%;
}

.alert {
    margin-bottom: 10px;
}

.small {
    font-size: 14px;
}
</style>